var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCriticalAsset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    fill: "currentColor",
    viewBox: "0 0 14 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.282 1a1 1 0 0 0-.894.55L1.311 3.694h2.773L5.42 1H3.28Zm3.256 0L5.2 3.693h3.465L7.41 1h-.87Zm1.974 0L9.77 3.693h2.929L11.65 1.559A1 1 0 0 0 10.753 1h-2.24Zm3.928 3.693H7.489v6.005l4.95-6.005Zm-5.951 6.002V4.693H1.558l4.931 6.002ZM1.495 1.1A2 2 0 0 1 3.282 0h7.47a2 2 0 0 1 1.796 1.119l1.4 2.853a.5.5 0 0 1-.062.539l-6.511 7.898a.5.5 0 0 1-.772 0L.113 4.51a.5.5 0 0 1-.06-.542L1.495 1.1Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalAsset);
export default __webpack_public_path__ + "static/media/criticalAsset.1647ba8477fe70ecb374099d32766605.svg";
export { ForwardRef as ReactComponent };